import CloseOutlinedIcon from '@uala/icons/CloseOutlinedIcon';
import React from 'react';

import Button from '../Button';
import useDesktopSize from '../hooks/useDesktopSize';
import Logo from '../images/logotipo.svg';
import AppStoreIcon from '../StoreIcons/AppStore';
import GooglePlay from '../StoreIcons/GooglePlay';
import {
  CloseIcon,
  MenuDivider,
  MenuDrawer,
  MenuFooter,
  MenuList,
  MenuProfileInfo,
  StoresLinks,
  StyledLogoTipo,
  TextInnerFooter
} from './styles';

export type MenuProps = {
  userPicture?: string;
  userName: string;
  open: boolean;
  onSignOut: () => void;
  onClose: () => void;
  onClickAppStore?: () => void;
  onClickGoogleplay?: () => void;
} & React.ComponentProps<typeof MenuDrawer>;

const Menu: React.FC<MenuProps> = ({
  id,
  open,
  userPicture,
  userName,
  onSignOut,
  onClose,
  children,
  onClickAppStore,
  onClickGoogleplay,
  ...rest
}) => {
  const isDesktop = useDesktopSize();
  return (
    <MenuDrawer
      {...rest}
      id={id}
      variant={isDesktop ? 'permanent' : 'temporary'}
      open={isDesktop || open}
      onClose={onClose}
      position="left"
    >
      <StyledLogoTipo width="50" height="25" src={Logo} alt="Ualá" />
      {!isDesktop && (
        <>
          <CloseIcon
            id={id && `${id}-close`}
            onClick={onClose}
            aria-label="Cerrar"
          >
            <CloseOutlinedIcon />
          </CloseIcon>
          <MenuProfileInfo userPicture={userPicture} userName={userName} />
          <MenuDivider />
        </>
      )}
      <MenuList divider={false}>{children}</MenuList>
      {!isDesktop && (
        <Button
          id={id && `${id}-logout`}
          variant="unfilled"
          size="standard"
          onClick={onSignOut}
          mt="auto"
          mb={6}
          mx={4}
        >
          Cerrar sesión
        </Button>
      )}
      {isDesktop && (
        <MenuFooter>
          <TextInnerFooter>Descargá la app desde</TextInnerFooter>
          <StoresLinks
            href="https://apps.apple.com/ar/app/ual%C3%A1/id1279808159"
            target="_blank"
            rel="noreferrer"
          >
            <AppStoreIcon onClick={onClickAppStore} aria-label="App Store" />
          </StoresLinks>
          <StoresLinks
            href="https://play.google.com/store/apps/details?id=ar.com.bancar.uala"
            target="_blank"
            rel="noreferrer"
          >
            <GooglePlay onClick={onClickGoogleplay} aria-label="Google Play" />
          </StoresLinks>
        </MenuFooter>
      )}
    </MenuDrawer>
  );
};

export default Menu;
